import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

export enum Breakpoints {
  XSmall = '(min-width: 0px) and (max-width: 424px)',
  Small = '(min-width: 425px) and (max-width: 767px)',
  Medium = '(min-width: 768px) and (max-width: 1023px)',
  Large = '(min-width: 1024px) and (max-width: 1919px)',
  XLarge = '(min-width: 1920px)',
}

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {

  private currentBreakpoint: string;

  get isLargeOrMore() {
    return this.currentBreakpoint === 'L'
      || this.currentBreakpoint === 'XL';
  }

  get isMediumOrLess() {
    return this.currentBreakpoint === 'XS'
      || this.currentBreakpoint === 'S'
      || this.currentBreakpoint === 'M';
  }

  get isMediumOrMore() {
    return this.currentBreakpoint === 'M'
      || this.currentBreakpoint === 'L'
      || this.currentBreakpoint === 'XL';
  }

  get isSmallOrMore() {
    return this.currentBreakpoint === 'S'
      || this.currentBreakpoint === 'M'
      || this.currentBreakpoint === 'L'
      || this.currentBreakpoint === 'XL';
  }

  constructor(private _breakpointObserver: BreakpointObserver,) {
    // Subscription to identify and set current breakpoint
    this._breakpointObserver.observe([
      Breakpoints.XLarge,
      Breakpoints.Large,
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall
    ]).subscribe(result => {
      if (result.breakpoints[Breakpoints.XSmall]) {
        this.currentBreakpoint = 'XS';
      }
      else if (result.breakpoints[Breakpoints.Small]) {
        this.currentBreakpoint = 'S';
      }
      else if (result.breakpoints[Breakpoints.Medium]) {
        this.currentBreakpoint = 'M';
      }
      else if (result.breakpoints[Breakpoints.Large]) {
        this.currentBreakpoint = 'L';
      }
      else if (result.breakpoints[Breakpoints.XLarge]) {
        this.currentBreakpoint = 'XL';
      }
    });
  }
}
